import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { MssFieldBaseFieldTypeComponent } from '../mss-field-base.component';
import { MSS_FORMLY_IMPORTS } from '../../formly-standalone-imports';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@Component({
  templateUrl: 'currency-multi-add.component.html',
  styleUrls: ['currency-multi-add.component.scss'],
  imports: [
    NgClass,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    ...MSS_FORMLY_IMPORTS,
  ],
  providers: [provideNgxMask({ thousandSeparator: ',' })],
})
export class CurrencyMultiAddFieldTypeComponent extends MssFieldBaseFieldTypeComponent {
  public static defaultOptions: FormlyFieldConfig = {
    props: {
      addonStart: '£',
      min: 0,
      ...MssFieldBaseFieldTypeComponent.focusBlurZeroDefault,
    },
  };

  public get numColumns(): number {
    return this.props.numColumns ?? 3;
  }
}
